import React, { useEffect, useRef } from "react";

const Map = () => {
  const mapRef = useRef(null);

  useEffect(() => {
    const loadMap = () => {
      if (window.google) {
        var uluru = {lat: 43.660396, lng: -79.750716};
        const map = new window.google.maps.Map(mapRef.current, {
            zoom: 7,
            center: uluru,
            styles: [
              {
                  "stylers": [
                      {
                          "hue": "#2c3e50"
                      },
                      {
                          "saturation": 250
                      }
                  ]
              },
              {
                  "featureType": "road",
                  "elementType": "geometry",
                  "stylers": [
                      {
                          "lightness": 50
                      },
                      {
                          "visibility": "simplified"
                      }
                  ]
              },
              {
                  "featureType": "road",
                  "elementType": "labels",
                  "stylers": [
                      {
                          "visibility": "off"
                      }
                  ]
              }
          ]
          });
          var marker = new window.google.maps.Marker({
              position: uluru,
              map: map,
              icon: ''
          });
      }
    };

    // Load the Google Maps API if not already loaded
    if (!window.google) {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyByDVB9Qjb110GGlqmy0humkWGIooE8dnw&callback=initMap`;
      script.async = true;
      script.defer = true;
      window.initMap = loadMap; // Set a global callback
      document.head.appendChild(script);
    } else {
      loadMap();
    }
  }, []);

  return <div ref={mapRef} style={{ width: "100%", height: "500px" }} />;
};

export default Map;
